import React from "react";
import PropTypes from "prop-types";
import TableHeader from "./TableHeader";
import Row from "./Row";

function DesktopVersion({ headers, featuresList }) {
  return (
    <div className="hidden lg:block">
      <div className="relative rounded-2xl border border-gray-700/50 bg-gray-900/95 shadow-2xl backdrop-blur-xl">
        {/* Subtle background glow */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-purple-500/5" />

        <table className="relative min-w-full">
          <TableHeader headers={headers} />
          <tbody className="divide-y divide-gray-700/50">
            {featuresList.map((category, categoryIndex) => (
              <React.Fragment key={category.id}>
                {/* Enhanced Category Header Row */}
                <tr className="bg-gradient-to-r from-gray-800/80 via-gray-800/60 to-gray-800/80 backdrop-blur-sm">
                  <td colSpan={headers.length} className="px-8 py-6">
                    <div className="flex items-center space-x-4">
                      <div className="shrink-0">
                        <div className="flex size-10 items-center justify-center rounded-xl bg-gradient-to-r from-blue-500 to-purple-500 shadow-lg">
                          <span className="text-sm font-bold text-white">{categoryIndex + 1}</span>
                        </div>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-white">{category.category}</h3>
                      </div>
                    </div>
                  </td>
                </tr>

                {/* Feature Rows for this Category */}
                {category.features.map((feature, featureIndex) => (
                  <Row key={feature.id} feature={feature} isEven={featureIndex % 2 === 0} />
                ))}
              </React.Fragment>
            ))}

            {/* Total Value Row */}
            <tr className="border-t-2 border-green-400/50 bg-gradient-to-r from-green-800/80 via-green-700/60 to-green-800/80 backdrop-blur-sm">
              <td colSpan={headers.length} className="p-8">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="shrink-0">
                      <div className="flex size-12 items-center justify-center rounded-xl bg-gradient-to-r from-green-500 to-emerald-500 shadow-lg">
                        <span className="text-lg font-bold text-white">∑</span>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-white">Total Monthly Value</h3>
                      <p className="text-green-200">Combined efficiency savings across all categories</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-4xl font-bold text-green-300">$1,200/mo</div>
                    <div className="mt-1 text-sm text-green-200">Annual Value: $14,400</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

DesktopVersion.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
  featuresList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      features: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          popoverText: PropTypes.string,
          rows: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string.isRequired,
              label: PropTypes.string.isRequired,
              popoverText: PropTypes.string,
            }),
          ).isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
};

export default DesktopVersion;
